import React from 'react';
import { useStoreon } from 'storeon/react';
import { RELATED_SERVICES_STORE_NAME, selectActualMeasure } from 'modules/related-services';
import { formatToRub } from 'utils/format';
import {
  ButtonWithGAClickButton,
  Card,
  CardActions,
  CardDescription,
  CardGrid,
  CardHeader,
  CardLogo,
  Section,
} from 'common/components';
import { KITCHEN_COLLECTIONS_CDN_PATH } from 'landings/kitchen-collections/kitchen-collections-constants';
import {
  collectionCardsGrid,
  collectionCard,
  collectionCardTitle,
  collectionCardsDescription,
  collectionCardIcon,
  collectionCardsButton,
} from './collection-cards-styles';

export const CollectionCards: React.FC = () => {
  const { relatedServices } = useStoreon(RELATED_SERVICES_STORE_NAME);
  const actualMeasure = selectActualMeasure(relatedServices);

  return (
    <Section>
      <CardGrid className={collectionCardsGrid}>
        <Card className={collectionCard}>
          <CardLogo
            className={collectionCardIcon}
            alt="Бесплатный замер помещения для кухни"
            src={`${KITCHEN_COLLECTIONS_CDN_PATH}/main-page/collection-cards/measure-order.jpg/measure-order.jpg`}
            title="Бесплатный замер помещения для кухни"
          />
          <CardHeader className={collectionCardTitle} as="h3" variant="h3">
            Закажите замер помещения
          </CardHeader>
          <CardDescription className={collectionCardsDescription}>
            Если вы&nbsp;не&nbsp;знаете размеры своей кухни и&nbsp;боитесь ошибиться
            в&nbsp;измерениях&nbsp;&mdash; закажите профессиональный замер помещения за&nbsp;
            {formatToRub(actualMeasure ? actualMeasure.price : 1500)}₽.
          </CardDescription>
          <CardActions>
            <ButtonWithGAClickButton
              className={collectionCardsButton}
              elementBlock="komplekty / catalogue"
              elementName="Закажите замер помещения"
              elementText="Заказать замер"
              href={
                actualMeasure
                  ? actualMeasure.serviceURL
                  : '/uslugi/checkout?categoryId=1832&regionId=34&measure=true'
              }
              target="_blank">
              Заказать замер
            </ButtonWithGAClickButton>
            <meta itemProp="priceCurrency" content="RUB" />
            <meta itemProp="price" content="0" />
          </CardActions>
        </Card>
        <Card className={collectionCard}>
          <CardLogo
            className={collectionCardIcon}
            alt="Инструкция по замеру кухни"
            src={`${KITCHEN_COLLECTIONS_CDN_PATH}/main-page/collection-cards/measure-article.jpg/measure-article.jpg`}
            title="Инструкция по замеру кухни"
          />
          <CardHeader className={collectionCardTitle} as="h3" variant="h3">
            Как измерить кухню
          </CardHeader>
          <CardDescription className={collectionCardsDescription}>
            Измерьте ваше помещение с&nbsp;помощью нашей инструкции и&nbsp;решите, какая техника
            и&nbsp;мебель вам понадобится.
          </CardDescription>
          <CardActions>
            <ButtonWithGAClickButton
              className={collectionCardsButton}
              elementBlock="komplekty / catalogue"
              elementName="Как измерить кухню"
              elementText="Читать инструкцию"
              href="/advice/kuhni/kak-izmerit-kuhnyu/">
              Читать инструкцию
            </ButtonWithGAClickButton>
            <meta itemProp="priceCurrency" content="RUB" />
            <meta itemProp="price" content="0" />
          </CardActions>
        </Card>
      </CardGrid>
    </Section>
  );
};
